import { Config } from "@/utils/config.utils";

export const findLocalityDetails = async (
    LocalitiesService: woosmap.map.LocalitiesService,
    publicId: string
) => {
    const detailsResponse = await LocalitiesService.getDetails({
        publicId: publicId,
        language: Config.getLocale()
    });

    return detailsResponse.result;
};
